import { Box, Typography } from '@mui/material';
import LinkifyParse from 'components/linkify-parse/linkify-parse.component';
import InformationField from 'components/options-fields/information-field/information-field.component';
import OrderOptionSelect from 'components/options-fields/order-option-select/order-option-select.component';
import React, { useEffect, useRef } from 'react';
import * as S from './order-options.styles';
import { useFieldNames } from 'components/new-order/useFieldNames.hooks';
import { useStoreOrderOptions } from 'pages/store/new-order-form/useStoreOrderOptions.hooks';

const OrderOptions = ({ label, store, orderType, defaultValue, children }) => {
  const {
    fieldNames: { orderOption: name, informationField },
  } = useFieldNames();
  const headingRef = useRef();

  const {
    orderOptions: options,
    defaultOrderOption: fallbackOrderOption,
    orderOption,
    skip,
  } = useStoreOrderOptions(store, orderType);

  const defaultOrderOption = defaultValue
    ? options?.find(oo => oo.optionName === defaultValue?.optionName)
    : null;
  const defaultInformation = defaultValue?.informationFieldInput ?? '';

  useEffect(() => {
    if (!skip) {
      setTimeout(() => {
        headingRef.current?.focus();
      }, 100);
    }
  }, [skip]);

  if (skip) return null;

  return (
    <Box data-testid="OrderOptions.Box">
      <Typography
        component="h3"
        variant="h6"
        gutterBottom
        ref={headingRef}
        tabIndex={-1}
      >
        Order Options
      </Typography>
      <OrderOptionSelect
        defaultValue={defaultOrderOption ?? fallbackOrderOption}
        sortedOptions={options}
        label={label}
        name={name}
      />

      {orderOption?.instructions && (
        <S.OptionInstructions component="div">
          <LinkifyParse>{orderOption.instructions}</LinkifyParse>
        </S.OptionInstructions>
      )}

      {orderOption?.informationField && (
        <InformationField
          selectedOption={orderOption}
          name={informationField}
          defaultValue={defaultInformation}
        />
      )}
      <Box marginTop="2em">{children}</Box>
    </Box>
  );
};

export default OrderOptions;
